/*
 * Copyright (c) 2021 CalAmp Corp.  All Rights Reserved
 */
import React, {useEffect, useMemo} from 'react';
import {useSelector} from 'react-redux';
import {SuperAdminDemoRoleIds} from '@ion/core/src/entities/LabelRulesValidator';
import {GlobalGroupChooserDialog} from '@ion/dls/src/components/groupchooser/GlobalGroupChooserDialog';
import GlobalGroupsSearch from '@ion/features/src/global-groups/search';
import {useSelectGlobalGroup} from '../../hooks/useSelectGlobalGroup';
import {roleSelector} from '../../store/selectors/initialization-selectors';

export interface GlobalGroupChooserMobile {
  toggleChangeGroup: Function;
}

/**
 * @GlobalGroupChooserMobile
 */
export const GlobalGroupChooserMobile = ({
  toggleChangeGroup
}: GlobalGroupChooserMobile) => {
  const onSelectGlobalGroup = useSelectGlobalGroup();
  const role                = useSelector(roleSelector);

  const {
    accountHierarchy,
    globalGroup,
    groupChooser : {
      isViewing: openChooser
    }
  } = useSelector(({globalGroup}) => globalGroup);
  const {username} = useSelector(({login: {user}}) => user);

  const onlyAccountId = useMemo(() => SuperAdminDemoRoleIds.includes(role?.id), [role?.id]);

  useEffect(function() {
    GlobalGroupsSearch.setAccounts(accountHierarchy);
  }, [accountHierarchy]);

  function onClose() {
    toggleChangeGroup?.();
  };

  return (
    <GlobalGroupChooserDialog allCrumbsClickable
      open={openChooser}
      onlyAccountId={onlyAccountId}
      accountHierarchy={accountHierarchy}
      onClose={onClose}
      selectedGroup={globalGroup}
      onSelectGroup={onSelectGlobalGroup}
      userName={username} />
  );
};

export default GlobalGroupChooserMobile;
